import React from 'react';
import { Col } from 'react-bootstrap';
import green from "../../../assets/images/green.svg";
import orange from "../../../assets/images/orange.png";
import red from "../../../assets/images/red.svg";
import PropTypes from 'prop-types';
import '../HealthStatus.scss';

const HealthCard = ({ status, cardHeading, id, setDetailview, setAdditonalText, disableDevice }) => {
  const isSuccess = status;
  let statusImage;
  if (isSuccess === "healthy") {
    statusImage = green;
  } else if (isSuccess === "critical") {
    statusImage = red;
  } else {
    statusImage = orange;
  }

  const handleDetailView = (id) => {
    setDetailview(id);
    if (id === 3) {
      setAdditonalText('camera');
    }
  };
  const isLongHeading = cardHeading && cardHeading.length > 12;
  const sanitizedId = id.toString().replace(/\s+/g, "_").toLowerCase(); 

  return (
    <Col xs={6} sm={6} md={6} xl={3} role="listitem">
      <button className={`healthCard ${isLongHeading ? "long-heading" : ""} ${disableDevice ? "not-allowed" : ""}`} 
        aria-labelledby={sanitizedId}
        tabIndex={0}
        // disabled={disableDevice}
        id={sanitizedId}
          onClick={() => {
            if (!disableDevice) {
              handleDetailView(id);
            }
          }}
      >
        {" "}
        <div className="statusImageWrapper">
          <img src={statusImage} alt="" className="statusImage" />
        </div>
        <h3 role="none">{cardHeading}</h3>
        <div className="statusTextWrapper">
          <p className={`statusText ${isSuccess}`}>{isSuccess}</p>
        </div>
      </button>
    </Col>
  );
};

HealthCard.propTypes = {
  status: PropTypes.string.isRequired, 
  cardHeading: PropTypes.string.isRequired,
  id: PropTypes.number,
  setDetailview: PropTypes.func,
  setAdditonalText: PropTypes.func,
  disableDevice: PropTypes.bool.isRequired, 
};

export default HealthCard;
